export default __webpack_public_path__ + "static/media/Melanio.3b8f495c.png";